import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVocalMicrophone: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vocal-microphone, singing, karaoke"><path d="M14.749 13.25L5.70407 21.2744C5.30833 21.6255 4.70712 21.6083 4.33297 21.2344L2.76559 19.666C2.39146 19.2919 2.37344 18.6907 2.72457 18.2949L10.749 9.25L14.749 13.25Z" fill="currentColor"/><path d="M16.499 2.5C19.2604 2.5 21.499 4.73858 21.499 7.5C21.499 10.2614 19.2604 12.5 16.499 12.5C16.2995 12.5 16.1025 12.4886 15.9091 12.4658L11.5341 8.08984C11.5114 7.89638 11.499 7.69958 11.499 7.5C11.499 4.73868 13.7377 2.50017 16.499 2.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconVocalMicrophone;
